import { useSelector } from 'react-redux';
import { getIsNewDesignEnabled } from '../modules/selectors/user';

/**
 * Whether the redesigned collection UI is enabled for the current user.
 *
 * Driven by the `featureFlags.newDesign` field on GET /api/me, so it is false
 * until the backend opts a user in. Every redesigned screen keeps its previous
 * implementation alongside the new one and picks between them with this hook.
 */
export const useNewDesign = (): boolean => useSelector(getIsNewDesignEnabled);

export default useNewDesign;
